 <!-- 搜索公用组件 -->
<template>
  <div>
    <div class="search-content">
      <el-form
        :inline="true"
        class="search-form"
        :model="formInline"
        size="small"
        @submit.native.prevent
      >
        <el-form-item
          v-for="(item,i) in conditions"
          :key="i"
          :label="item.type == 'button' ? '' : item.label"
        >
          <!-- 输入框 -->
          <el-input
            v-if="item.type == 'input'"
            v-model="formInline[item.name]"
            :placeholder="item.placeholder?item.placeholder:item.label"
            @keyup.enter.native="$emit('handleSearch', formInline);"
          ></el-input>
          <!-- 下拉框 -->
          <el-select
            clearable
            v-if="item.type == 'select'"
            v-model="formInline[item.name]"
            :placeholder="item.label"
          >
            <el-option
              v-for="(option,i) in item.options"
              :key="i"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
          <!-- 级联下拉框 -->
          <el-cascader
            clearable
            v-if="item.type == 'cascader'"
            v-model="formInline[item.name]"
            :placeholder="item.label"
            :props="{ lazy: true, lazyLoad: item.lazyLoad }"
          ></el-cascader>
          <!-- 日期选择器 -->
          <el-date-picker
            v-if="item.type == 'date'"
            v-model="formInline[item.name]"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>

          <el-date-picker
            v-if="item.type == 'dateMonth'"
            v-model="formInline[item.name]"
            type="month"
            align="right"
            value-format="yyyy-M"
            :placeholder="item.label"
          >></el-date-picker>
          <!-- 按钮 -->
          <el-button
            v-if="item.type == 'button'"
            type="primary"
            @click="onSubmit(item.clean)"
          >{{ item.label }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
/** 表格头部搜索组件
 * props 参数conditions
 * name:属性key; type分为:input|select|date;
 * options:type为select需下拉选项
 * 例：{ label: "团队名称", name: "name", type: "input" },
 *
 */
export default {
  name: 'SearchForm',
  props: {
    conditions: {
      type: Array,
      required: true
    },
    clean: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formInline: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    onSubmit (e) {
      if (e) {
        this.formInline = {}
      }
      this.$emit('handleSearch', this.formInline);
    }
  },
  watch: {
    clean (a, b) {
      this.formInline = {}
    }
  }
};
</script>
<style lang='scss' >
</style>



// WEBPACK FOOTER //
// src/components/common/page/SearchForm.vue